import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  bottom: 5px;
  left: 220px;
  text-align: center;
  color: #667;
  padding: 0 10px;
  font-size: 14px;
  height: 20px;
  width: 80px;
  font-family: monospace;

  z-index: 2000;

  @media (max-width: 768px) {
    display: none;
  }
  // Rotate 90 degrees and adjust positioning

  &.warning {
    color: #f80;
  }

  &.danger {
    color: #f00;
  }
`;
